/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import u from '@main';
import '@vendor/swiper/swiper-bundle.min.js?0801e7ec9bed15bc93ed5677';
u.importCSS('@vendor/swiper/swiper-bundle.min.css');

const bannerSwiper = new Swiper('.j-banner-swiper', {
  slidesPerView: 1,
  freeMode: true,
  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: '.swiper-pagination',
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + '0' + (index + 1) + "</span>";
    },
    clickable: true,
  },
  lazy: {
    loadPrevNext: true,
  },
});
